import React, {Component} from 'react'
import Video from '../Video'
import Grid from '../Grid'
import './video-grid.css'

class VideoGrid extends Component {

  render() {
    let data = this.props.data;
    let videos = data.map(
      (datum, index) =>
        <Video data={datum} index={index}></Video>);

    return (
      <div>
        <Grid
          data = {videos}
          nCellsPerRow = {this.props.nCellsPerRow}
          nCellsPerRowMobile = {this.props.nCellsPerRowMobile}>
        </Grid>
      </div>
    );
  }
}

export default VideoGrid;
